/* Banita/Buyback v8 — grid countdown (sin last_ts) + auto-refresh usando SOLO ?section_id=
   Fix cross-browser: guard global por sección + boot delay tras replace
   Cargar globalmente desde theme.liquid:
   {{ 'buyback-section.js' | asset_url | script_tag }}
*/
(function(){

  // --- Constantes/Selectores ---
  var SECTION_ATTR = "data-buyback-section-id";     // atributo estable en <section …>
  var SELECTOR_HEADER = ".buyback-prices__header";
  var SELECTOR_COUNTDOWN = ".bbp-countdown";
  var SCAN_INTERVAL_MS = 1500;                      // rescaneo periódico por si la sección pinta tarde
  var REFRESH_COOLDOWN_MS = 2500;                   // evita bucles de refresh
  var BOOT_DELAY_MS = 1100;                         // evita re-refresh inmediato en instancias nuevas
  var moDebounceTimer = null;                       // debounce del MutationObserver
  
  // *** NUEVA CONSTANTE ***
  var TARGET_SECTION_ID = "buyback-prices";         // ID de archivo de la sección a cargar con ?section_id=

  // Guard global por sección (persiste entre reemplazos)
  window.__buybackRefreshGuard = window.__buybackRefreshGuard || Object.create(null);

  // --- Utils ---
  function $(sel, ctx){ return (ctx||document).querySelector(sel); }
  function fmt(sec){
    if (sec < 0) sec = 0;
    var m = Math.floor(sec/60), s = Math.floor(sec%60);
    return String(m).padStart(2,"0")+":"+String(s).padStart(2,"0");
  }

  function nextFromGrid(step, now){
    var OFFSET_SEC = 60;
    var base = Math.floor((now - OFFSET_SEC) / step) * step + OFFSET_SEC;
    return base + step;
  }
  
  function ensureVisible(el){
    if (!el) return;
    el.style.display='inline-block';
    el.style.visibility='visible';
    el.style.opacity='1';
    el.style.color='#fff';
  }

  // --- Fetch helper: USANDO ?section_id= ---
  function fetchViaSections(sectionId){
    // Nota: sectionId no se usa aquí, ya que el fetch es para un ID estático (TARGET_SECTION_ID).
    // Esto asume que todas las secciones con SECTION_ATTR deben cargar la misma sección de repuesto.
    var url = new URL(window.location.pathname, window.location.origin);
    
    // *** CAMBIO CLAVE ***
    url.searchParams.set("section_id", TARGET_SECTION_ID); 
    
    url.searchParams.set("_", Date.now());
    
    return fetch(url.toString(), { credentials:"same-origin", cache:"no-store" })
      .then(function(r){ 
          if(!r.ok) throw new Error("HTTP "+r.status); 
          // Este endpoint devuelve el HTML directo, no JSON.
          return r.text(); 
      })
      .then(function(html){
        // No se requiere parseo de JSON, solo verificar el HTML.
        if (!html || html.length < 50) throw new Error("section_id HTML vacío");
        return html;
      });
  }

  // --- Reemplazo y re-init ---
  function replaceSection(root, incomingHTML){
    // Limpieza defensiva de interval si existiera
    if (root._buybackInterval) { try{ clearInterval(root._buybackInterval); }catch(_){ } root._buybackInterval = null; }

    var sectionId = root.getAttribute(SECTION_ATTR);
    var rootId    = root.id;

    var temp = document.createElement("div");
    // El HTML devuelto por ?section_id=... es el contenido completo de la sección.
    temp.innerHTML = incomingHTML;

    // Buscar el nodo hijo que coincide con el ID de la sección actual.
    var incoming = temp.querySelector("["+SECTION_ATTR+"='"+sectionId+"']");
    if (!incoming && rootId) incoming = temp.querySelector("#"+CSS.escape(rootId));
    if (!incoming) incoming = temp.firstElementChild; // Fallback

    if (!incoming) throw new Error("section node no encontrado en HTML devuelto");

    root.replaceWith(incoming);

    // Re-init en la nueva instancia
    initOne(incoming);
  }

  // --- Timer/contador por instancia ---
  function startTimer(root){
    // Evita múltiples intervals sobre el mismo nodo
    if (root._buybackInterval) { clearInterval(root._buybackInterval); root._buybackInterval = null; }

    var header = $(SELECTOR_HEADER, root);
    var countdownEl = $(SELECTOR_COUNTDOWN, root);
    if (!header || !countdownEl){
      console.warn("[Banita/Buyback] header o .bbp-countdown no encontrados en la instancia", root);
      return;
    }

    // Leemos solo el paso (step) desde el atributo data-interval; ignoramos completamente cualquier timestamp
    var step = parseInt(root.getAttribute("data-interval") || "600", 10);
    if (isNaN(step) || step <= 0) step = 600;

    var reloading = false;
    var sectionKey = root.getAttribute(SECTION_ATTR);

    // Boot guard: si acabamos de refrescar esta sección, espera un poco antes del primer tick
    var bootBlockedMs = 0;
    var lastGlobalRefresh = Number(window.__buybackRefreshGuard[sectionKey] || 0);
    var nowMsBoot = Date.now();
    if (nowMsBoot - lastGlobalRefresh < BOOT_DELAY_MS) {
      bootBlockedMs = BOOT_DELAY_MS - (nowMsBoot - lastGlobalRefresh);
    }

    function refresh(){
      if (reloading) return;

      var nowMs = Date.now();
      var lastRefreshMs = Number(root._lastRefreshMs || 0);
      var lastGlobal = Number(window.__buybackRefreshGuard[sectionKey] || 0);

      // Cooldown local por nodo
      if (nowMs - lastRefreshMs < REFRESH_COOLDOWN_MS) {
        return;
      }
      // Cooldown global por sección (evita re-refresh inmediato en la nueva instancia tras replace)
      if (nowMs - lastGlobal < REFRESH_COOLDOWN_MS) {
        return;
      }

      root._lastRefreshMs = nowMs;
      window.__buybackRefreshGuard[sectionKey] = nowMs; // ← guarda para la próxima instancia
      reloading = true;

      fetchViaSections(sectionKey)
        .then(function(html){
          // El html es directo, no JSON.
          if (!html || html.length < 50) throw new Error("sections vacío");
          replaceSection(root, html);
        })
        .catch(function(err){
          console.error("[Banita/Buyback] fetch ?section_id falló → hard reload", err);
          window.location.reload();
        })
        .finally(function(){
          setTimeout(function(){ reloading = false; }, 500);
        });
    }

    function tick(){
      if (!document.body.contains(root)){
        clearInterval(root._buybackInterval); root._buybackInterval = null;
        return;
      }

      var c = $(SELECTOR_COUNTDOWN, root);
      if (!c){
        clearInterval(root._buybackInterval); root._buybackInterval = null;
        return;
      }

      // Respeta boot delay global tras un replace
      var guard = Number(window.__buybackRefreshGuard[sectionKey] || 0);
      var nowMs = Date.now();
      if (nowMs - guard < BOOT_DELAY_MS) {
        return;
      }

      var now = Math.floor(nowMs/1000);
      var next = nextFromGrid(step, now);
      var remain = next - now;

      c.textContent = fmt(remain);
      ensureVisible(c);

      if (remain <= 1) {
        if (!reloading) {
          refresh();
        }
      }
    }

    // primer tick: si hay boot delay pendiente, difiere el arranque
    if (bootBlockedMs > 0) {
      setTimeout(function(){
        tick();
        root._buybackInterval = setInterval(tick, 1000);
      }, bootBlockedMs);
    } else {
      tick();
      root._buybackInterval = setInterval(tick, 1000);
    }
  }

  // --- Init por nodo (evita dobles inits) ---
  function initOne(root){
    try{
      if (root._buybackInited) return;       // evita doble init por nodo
      root._buybackInited = true;            // marca JS
      root.setAttribute("data-buyback-inited","1"); // marca visible en DOM
      startTimer(root);
    }catch(e){
      console.error("[Banita/Buyback] initOne error:", e);
    }
  }

  // --- Escaneo y re-escaneo (solo nuevas instancias) ---
  function scanAll(){
    var nodes = document.querySelectorAll("["+SECTION_ATTR+"]:not([data-buyback-inited])");
    if (!nodes.length) {
      if (!scanAll._loggedOnce){
        scanAll._loggedOnce = true;
      }
      return;
    }
    nodes.forEach(initOne);
  }

  // Primer escaneo y rescaneos periódicos
  scanAll();
  setInterval(scanAll, SCAN_INTERVAL_MS);

  // Re-init si el tema reinyecta secciones dinámicamente (debounced)
  var mo = new MutationObserver(function(muts){
    var needsScan = muts.some(function(m){
      return Array.from(m.addedNodes||[]).some(function(n){
        return n.nodeType === 1 && n.hasAttribute && n.hasAttribute(SECTION_ATTR);
      });
    });
    if (needsScan){
      if (moDebounceTimer) clearTimeout(moDebounceTimer);
      moDebounceTimer = setTimeout(function(){
        scanAll();
      }, 250);
    }
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });

  // Theme Editor events
  document.addEventListener("shopify:section:load", function(e){
    var id = e && e.detail && e.detail.sectionId;
    var node = id && document.querySelector("["+SECTION_ATTR+"='"+id+"']");
    if (node){
      initOne(node);
    }
  });
  document.addEventListener("shopify:section:select", function(e){
    var id = e && e.detail && e.detail.sectionId;
    var node = id && document.querySelector("["+SECTION_ATTR+"='"+id+"']");
  });
})();

/* Random flash on Buyback Price cells (one-at-a-time) */
(function setupBuybackFlash(){
  const SECTION_ATTR = 'data-buyback-section-id';
  const SELECTOR_SECTION = `[${SECTION_ATTR}]`;
  const SELECTOR_CELLS = 'td.payout';

  // Respect users who prefer reduced motion
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    return;
  }

  // Avoid double-initializing this module globally
  if (window.__buybackFlashModuleLoaded) return;
  window.__buybackFlashModuleLoaded = true;

  function startFlash(root){
    if (!root || root.__buybackFlashInited) return;
    root.__buybackFlashInited = true;

    const cells = Array.from(root.querySelectorAll(SELECTOR_CELLS));
    if (!cells.length) return;

    let timer = null;
    let flashing = false; // ensure only one active flash

    function flashOnce(){
      if (flashing) return;
      const cell = cells[Math.floor(Math.random() * cells.length)];
      if (!cell) return;

      flashing = true;

      // restart animation by toggling class
      cell.classList.remove('bbp-flash');
      void cell.offsetWidth; // reflow
      cell.classList.add('bbp-flash');

      const cleanup = () => {
        cell.classList.remove('bbp-flash');
        cell.removeEventListener('animationend', cleanup);
        flashing = false;
      };
      cell.addEventListener('animationend', cleanup);
    }

    function scheduleNext(){
      const delay = Math.random() * 500;
      timer = setTimeout(() => {
        flashOnce();
        scheduleNext();
      }, delay);
    }

    // Pause when section is off-screen
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          if (!timer) scheduleNext();
        } else {
          if (timer) { clearTimeout(timer); timer = null; }
          flashing = false;
        }
      });
    }, { threshold: 0.1 });

    io.observe(root);

    // Clean up if node gets removed (e.g., after AJAX replace)
    const kill = () => { if (timer) clearTimeout(timer); io.disconnect(); };
    root.addEventListener('DOMNodeRemoved', kill, { once: true });
  }

  function scanAll(){
    document.querySelectorAll(SELECTOR_SECTION).forEach(startFlash);
  }

  // Initial scan
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    scanAll();
  } else {
    document.addEventListener('DOMContentLoaded', scanAll, { once: true });
  }

  // Re-scan after dynamic DOM changes (e.g., section refresh)
  let moDebounce = null;
  const mo = new MutationObserver(() => {
    if (moDebounce) cancelAnimationFrame(moDebounce);
    moDebounce = requestAnimationFrame(scanAll);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();